import { AppStatus, Session, SessionState } from '@/redux'
import { APIClient } from '@/services'
import { Profile } from '@/types'
import { TypeGuards } from '@codeleap/common'
import { AnyRecord } from '@codeleap/types'
import { navigate as _navigate } from 'gatsby'

export const openRegistrationWall = (isUnknown = true, onAuth?: AnyRecord) => {
  return () => {
    if (isUnknown) {
      return AppStatus.setModal('authWall')
    }

    if (TypeGuards.isFunction(onAuth)) {
      onAuth?.()
    }
  }
}

export const maybeOpenRegistrationWall = (
  open = true,
  isOpenModal = false,
  variant?: SessionState['registrationWallVariant'],
) => {
  const profile = APIClient.Session.QueryKeys.me.getData()
  const isUnknown = TypeGuards.isNil(profile)

  if (isUnknown && isOpenModal) {
    Session.setRegistrationWallVariant(variant ?? null)
    AppStatus.setModal('authWall')
  } else if (isUnknown && open) {
    _navigate('/auth/signup')
  }
  return !isUnknown
}

export const ensureProfileCompletion = async () => {
  const profile = APIClient.Session.QueryKeys.me.getData() as unknown as Profile

  if (APIClient.Session.isLoggedIn() && !!profile) {
    return await APIClient.Session.ensureProfileDetails(profile)
  }

  APIClient.UnknownProfile.maybeOpenRegistrationWall()

  const isLoggedIn = await APIClient.Session.ensureLoggedInTopic.wait(null)

  if (!isLoggedIn) {
    throw new Error('User is not logged in', { cause: 'ensureProfileComplete' })
  }

  const updatedProfile = APIClient.Session.QueryKeys.me.getData() as unknown as Profile

  return await APIClient.Session.ensureProfileDetails(updatedProfile)
}
